import { ArrowRight } from "lucide-react";

type Props = {
  children?: React.ReactNode;
  href?: string;
};

export default function SocialButton({ children, href }: Props) {
  return (
    <div className="group bg-surface-raised/70 backdrop-blur-sm border border-line w-full text-ink hover:bg-brand hover:text-on-brand hover:border-brand transition-colors duration-200 cursor-pointer dark:bg-[#22262F]/50 dark:border-2 dark:border-[#909090]/2 dark:text-white dark:hover:bg-[#22262F]/20 dark:hover:text-white dark:hover:border-[#909090]/2">
      <a
        href={href}
        className="group flex justify-between font-light text-[18px] py-3 pr-3 pl-4"
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
        <ArrowRight className="last:group-hover:-rotate-45 transition-transform duration-100" />
      </a>
    </div>
  );
}
